// Splits a flat, ordered field list into pages. A page boundary starts at any
// sect-title field explicitly marked new_page: true in the form builder —
// that field becomes the first item of its own new page, so its title
// doubles as the page heading. Everything before the first such marker (or
// the entire form, when there are none) is page 1 — so a form with no
// new_page markers at all renders exactly as it always has: one page.
export function splitFieldsIntoPages(fields) {
  const pages = [[]];
  fields.forEach((field) => {
    const isPageStart =
      field.field_type?.includes("sect-title") && field.new_page === true;
    if (isPageStart && pages[pages.length - 1].length > 0) {
      pages.push([]);
    }
    pages[pages.length - 1].push(field);
  });
  return pages;
}


export function pageHasErrors(pageFields, errors) {
  if (!errors) return false;
  return pageFields.some((field) => {
    if (field.field_label && errors[field.field_label]) return true;
    if (Array.isArray(field.field_items)) {
      return field.field_items.some(
        (item) =>
          typeof item !== "string" &&
          item.field_label &&
          errors[field.field_type]?.[item.field_label]
      );
    }
    return false;
  });
}

// Formik field names (matching getName()) for every field on a page,
// including composite sub-fields — used to mark a page's fields touched
// before validating, so a blocked "Next" actually surfaces its error
// messages instead of silently refusing to advance.
export function collectPageFieldNames(pageFields) {
  const names = [];
  pageFields.forEach((field) => {
    if (field.field_label) names.push(field.field_label);
    if (Array.isArray(field.field_items)) {
      field.field_items.forEach((item) => {
        if (typeof item !== "string" && item.field_label) {
          names.push(`${field.field_type}.fields.${item.field_label}`);
        }
      });
    }
  });
  return names;
}
